export default {
  namespaced: true,
  state: {
    orderInfo: {},
    placeOrderInfo: {},
    orderSuccessInfo: {},
  },
  getters: {
    getOrderInfo: state => {
      return state.orderInfo
    },
    getPlaceOrderInfo: state => {
      return state.placeOrderInfo
    },
    getOrderSuccessInfo: state => {
      return state.orderSuccessInfo
    },
  },
  mutations: {
    setOrderInfo (state, orderInfo) {
      state.orderInfo = orderInfo
    },
    setPlaceOrderInfo (state, orderInfo) {
      state.placeOrderInfo = orderInfo
    },
    setOrderSuccessInfo (state, orderInfo) {
      state.orderSuccessInfo = orderInfo
    },
  }
}
